import { combineReducers } from "redux";
import login from "./login";
import user from "./user";
// import register from './register';

export default combineReducers({ login, user });
